
import { defineComponent } from "vue";

export default defineComponent({
  name: "SuccessModal",
  props: {
    message: {
      type: String,
      default: "Votre action a été effectuée avec succès",
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeSuccessModal");
    },
  },
});
